import enUS from "./en-US";
import jaJP from "./ja-JP";
import zhCN from "./zh-CN";
import zhTW from "./zh-TW";
var localeMap = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'zh-TW': zhTW,
  'ja-JP': jaJP
};
export default localeMap;
export var mainlandArea = function mainlandArea(locale) {
  return locale === 'zh-CN';
};